export default "__VITE_ASSET__92b82f57__"